import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; // Or use @highcharts/react components
import 'highcharts/modules/exporting';

interface ChartProps {
  title: string;
  height: number;
}

const LowMarginLowVolume: React.FC<ChartProps> = ({ title, height = 345 }) => {
  const [categories, setCategories] = React.useState([]);
  const [currentGp, setCurrentGp] = React.useState([]);
  const [modelGp, setModelGp] = React.useState([]);
  const [currentPct, setCurrentPct] = React.useState([]);
  const [modelPct, setModelPct] = React.useState([]);
  const [totalSales, setTotalSales] = React.useState([]);
  
  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
  React.useEffect(() => {
    fetch(`/dashboard/low-margin-low-volume/?entity_id=${localStorage.getItem('entity_id')}`)
      .then(response => response.json())
      .then(data => 
        setTimeout(() => {
          setCategories(data.categories);
          setCurrentGp(data.current_gp);
          setModelGp(data.model_gp);
          setTotalSales(data.total_sales);
          setCurrentPct(data.current_pct);
          setModelPct(data.model_pct);
        }, 100)
      );

    const handleResize = () => {
      if (chartComponentRef.current && chartComponentRef.current.chart) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const options: Highcharts.Options = {
        chart: {
            type: 'column',
            zooming: {
                type: 'xy' as const
            }
        },
        title: {
            text: title,
            align: 'left',
            style: {
                fontFamily: 'Trebuchet MS'
            }
        },
        
        xAxis: {
            crosshair: true,
            accessibility: {
                description: ''
            },
            title: {
                text: 'Products',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            labels: {
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            categories: categories.length > 0 ? categories : []
        },
        yAxis: {
            min: 0,
            labels: {
              formatter: function(this: Highcharts.AxisLabelsFormatterContextObject) {
                  return (this.value as number) + '%';
              },
              style: {
                  fontFamily: 'Trebuchet MS'
              }
          },
          title: {
            text: 'Gross Profit (%)',
            style: {
                fontFamily: 'Trebuchet MS'
            }
          }
        },
        tooltip: {
            valueSuffix: ' (%)',
            style: {
                fontFamily: 'Trebuchet MS'
            }
        },
        plotOptions: {
          column: {
              pointPadding: 0.2,
              borderWidth: 0
          }
        },
        series: [
            {
              name: 'Current Gross Profit',
              type: 'column',
              data: currentPct.length > 0 ? currentPct : [],
              dataLabels: {
                formatter: function(this: Highcharts.Point) {
                  return (this.y as number).toFixed(2) + '%';
                }
              }
            },
            {
                type: 'column',
                color: 'darkblue',
                name: 'Gross Profit Goal',
                data: modelPct.length > 0 ? modelPct : [],
                dataLabels: {
                  formatter: function(this: Highcharts.Point) {
                    return (this.y as number).toFixed(2) + '%';
                  }
                }
            }
        ]
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate={true}
                exportEnabled={true}
                ref={chartComponentRef}
                containerProps={{ style: { width: '100%', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
            />
        </div>
    );
};

export default LowMarginLowVolume;
